import styled from "@emotion/styled";

export type ForestTileProps = {
  backgroundImage?: string;
  isFlipped?: boolean;
  isNudged?: boolean;
  onClick?: () => void;
  $isForestEmpty?: boolean;
  $isCentered?: boolean;
};

export const ForestTile = styled.li<ForestTileProps>`
  margin: ${(props) => (props.$isForestEmpty ? "0px 5px" : "-10px 5px")};
  position: relative;
  transition: transform 0.2s ease;
  left: ${(props) =>
    props.$isForestEmpty || props?.$isCentered
      ? "0px"
      : props.isNudged
      ? "-27px"
      : "27px"};
  background-image: url(/images/app/hexagon.png);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100%;
  z-index: 1;
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};

  &:hover {
    transform: translateY(-2px);
  }

  @media ${(props) => props.theme.bp.mobileDown} {
    margin: ${(props) =>
      props.$isForestEmpty || props?.$isCentered
        ? "32px 0px 0px 0px"
        : "-10px 5px"};
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    margin: ${(props) => (props.$isForestEmpty ? "0px 10px" : "-14px 10px")};
    left: ${(props) =>
      props.$isForestEmpty || props?.$isCentered
        ? "0px"
        : props.isNudged
        ? "-46px"
        : "46px"};
  }
`;

export const ForestTileInner = styled.div`
  display: block;
  height: 100px;
  width: 100px;
  outline: none;
  position: relative;
  transition: transform 0.2s ease;
  z-index: 1;

  @media ${(props) => props.theme.bp.tabletUp} {
    height: 164px;
    width: 164px;
  }
`;

export const ForestTileSparkles = styled.span<{ isSingle?: boolean }>`
  background-image: url("data:image/svg+xml,%3Csvg id='sparkles' xmlns='http://www.w3.org/2000/svg' width='64' height='68' viewBox='0 0 64 68'%3E%3Cdefs%3E%3Cstyle%3E @-webkit-keyframes fadeinout %7B 0%25,100%25 %7B opacity: 0.2; %7D 50%25 %7B opacity: 1; %7D %7D @keyframes fadeinout %7B 0%25,100%25 %7B opacity: 0.2; %7D 50%25 %7B opacity: 1; %7D %7D @-webkit-keyframes fadeinoutsemi %7B 0%25,100%25 %7B opacity: 0.5; %7D 50%25 %7B opacity: 1; %7D %7D @keyframes fadeinoutsemi %7B 0%25,100%25 %7B opacity: 0.5; %7D 50%25 %7B opacity: 1; %7D %7D @-webkit-keyframes fadeinoutsubtle %7B 0%25,100%25 %7B opacity: 0.75; %7D 50%25 %7B opacity: 1; %7D %7D @keyframes fadeinoutsubtle %7B 0%25,100%25 %7B opacity: 0.75; %7D 50%25 %7B opacity: 1; %7D %7D .cls-1 %7B fill: %23f7e6b4; -webkit-animation: fadeinout 1.1s infinite; animation: fadeinout 1.1s infinite; %7D .cls-1, .cls-2, .cls-3, .cls-4 %7B fill-rule: evenodd; %7D .cls-2 %7B fill: %23f8d571; -webkit-animation: fadeinoutsemi 0.5s infinite; animation: fadeinoutsemi 0.5s infinite; %7D .cls-3 %7B fill: %23f5b90f; -webkit-animation: fadeinoutsubtle 0.4s infinite; animation: fadeinoutsubtle 0.4s infinite; %7D .cls-4 %7B fill: %23f5860f; -webkit-animation: fadeinout 1.3s infinite; animation: fadeinout 1.3s infinite; %7D %3C/style%3E%3C/defs%3E%3Cpath id='Ellipse_681_copy_2' data-name='Ellipse 681 copy 2' class='cls-1' d='M1886.5,2111.15c5.25,0,9.5.38,9.5,0.85s-4.25.85-9.5,0.85-9.5-.38-9.5-0.85S1881.25,2111.15,1886.5,2111.15Zm0.25-10.15c0.41,0,.75,5.36.75,11.28s-0.34,10.72-.75,10.72-0.75-4.8-.75-10.72S1886.34,2101,1886.75,2101Zm-0.72,10.75c2.47-2.79,4.64-4.88,4.83-4.66s-1.65,2.67-4.12,5.46-4.64,4.87-4.84,4.65S1883.55,2114.54,1886.03,2111.75Zm-3.89-4.66c0.19-.22,2.36,1.87,4.83,4.66s4.32,5.23,4.13,5.45-2.36-1.86-4.84-4.65S1881.94,2107.31,1882.14,2107.09Z' transform='translate(-1832 -2056)'/%3E%3Cpath id='Ellipse_681_copy_3' data-name='Ellipse 681 copy 3' class='cls-2' d='M1839.5,2081.92c4.14,0,7.5.26,7.5,0.58s-3.36.58-7.5,0.58-7.5-.26-7.5-0.58S1835.36,2081.92,1839.5,2081.92Zm0.2-6.92c0.32,0,.59,3.66.59,7.69s-0.27,7.31-.59,7.31-0.59-3.27-.59-7.31S1839.37,2075,1839.7,2075Zm-0.57,7.33c1.95-1.9,3.66-3.33,3.81-3.17s-1.3,1.81-3.25,3.71-3.67,3.33-3.82,3.18S1837.17,2084.23,1839.13,2082.33Zm-3.07-3.17c0.15-.16,1.86,1.27,3.81,3.17s3.41,3.57,3.26,3.72-1.86-1.27-3.82-3.18S1835.9,2079.31,1836.06,2079.16Z' transform='translate(-1832 -2056)'/%3E%3Cpath id='Ellipse_681_copy_7' data-name='Ellipse 681 copy 7' class='cls-2' d='M1863.5,2089.92c4.14,0,7.5.26,7.5,0.58s-3.36.58-7.5,0.58-7.5-.26-7.5-0.58S1859.36,2089.92,1863.5,2089.92Zm0.2-6.92c0.32,0,.59,3.66.59,7.69s-0.27,7.31-.59,7.31-0.59-3.27-.59-7.31S1863.37,2083,1863.7,2083Zm-0.57,7.33c1.95-1.9,3.66-3.32,3.81-3.17s-1.3,1.81-3.25,3.71-3.67,3.33-3.82,3.18S1861.17,2092.23,1863.13,2090.33Zm-3.07-3.17c0.15-.15,1.86,1.27,3.81,3.17s3.41,3.57,3.26,3.72-1.86-1.27-3.82-3.18S1859.9,2087.31,1860.06,2087.16Z' transform='translate(-1832 -2056)'/%3E%3Cpath id='Ellipse_681_copy_6' data-name='Ellipse 681 copy 6' class='cls-1' d='M1866.5,2066.15c5.25,0,9.5.38,9.5,0.85s-4.25.85-9.5,0.85-9.5-.38-9.5-0.85S1861.25,2066.15,1866.5,2066.15Zm0.25-10.15c0.41,0,.75,5.36.75,11.28s-0.34,10.72-.75,10.72-0.75-4.8-.75-10.72S1866.34,2056,1866.75,2056Zm-0.72,10.75c2.47-2.79,4.64-4.88,4.83-4.66s-1.65,2.67-4.12,5.46-4.64,4.87-4.84,4.65S1863.55,2069.54,1866.03,2066.75Zm-3.89-4.66c0.19-.22,2.36,1.87,4.83,4.66s4.32,5.23,4.13,5.45-2.36-1.86-4.84-4.65S1861.94,2062.31,1862.14,2062.09Z' transform='translate(-1832 -2056)'/%3E%3Cpath id='Ellipse_681_copy_4' data-name='Ellipse 681 copy 4' class='cls-3' d='M1886.5,2082.15c5.25,0,9.5.38,9.5,0.85s-4.25.85-9.5,0.85-9.5-.38-9.5-0.85S1881.25,2082.15,1886.5,2082.15Zm0.25-10.15c0.41,0,.75,5.36.75,11.28s-0.34,10.72-.75,10.72-0.75-4.8-.75-10.72S1886.34,2072,1886.75,2072Zm-0.72,10.75c2.47-2.79,4.64-4.88,4.83-4.66s-1.65,2.67-4.12,5.46-4.64,4.87-4.84,4.65S1883.55,2085.54,1886.03,2082.75Zm-3.89-4.66c0.19-.22,2.36,1.87,4.83,4.66s4.32,5.23,4.13,5.45-2.36-1.86-4.84-4.65S1881.94,2078.31,1882.14,2078.09Z' transform='translate(-1832 -2056)'/%3E%3Cpath id='Ellipse_681_copy_5' data-name='Ellipse 681 copy 5' class='cls-4' d='M1849.5,2112.15c5.25,0,9.5.38,9.5,0.85s-4.25.85-9.5,0.85-9.5-.38-9.5-0.85S1844.25,2112.15,1849.5,2112.15Zm0.25-10.15c0.41,0,.75,5.36.75,11.28s-0.34,10.72-.75,10.72-0.75-4.8-.75-10.72S1849.34,2102,1849.75,2102Zm-0.72,10.75c2.47-2.79,4.64-4.88,4.83-4.66s-1.65,2.67-4.12,5.46-4.64,4.87-4.84,4.65S1846.55,2115.54,1849.03,2112.75Zm-3.89-4.66c0.19-.22,2.36,1.87,4.83,4.66s4.32,5.23,4.13,5.45-2.36-1.86-4.84-4.65S1844.94,2108.31,1845.14,2108.09Z' transform='translate(-1832 -2056)'/%3E%3C/svg%3E%0A");
  background-position: 0;
  background-repeat: repeat;
  background-size: 45px;
  content: "";
  display: block;
  height: 45px;
  left: ${(props) => (props.isSingle ? "50%" : "5%")};
  opacity: 0.8;
  position: absolute;
  top: 22%;
  width: ${(props) => (props.isSingle ? "38px" : "90%")};
  transform: translate(${(props) => (props.isSingle ? "-50%" : "0")});

  @media ${(props) => props.theme.bp.tabletUp} {
    top: 30%;
    background-size: 55px;
    height: ${(props) => (props.isSingle ? "55px" : "58px")};
  }
`;

export const ForestTileStack = styled.span<{ value?: string | number }>`
  background-color: rgba(0, 0, 0, 0.08);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  bottom: 14px;
  display: block;
  height: 13px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 50px;

  @media ${(props) => props.theme.bp.tabletUp} {
    bottom: 20px;
    height: 20px;
    width: 70px;
  }

  &::before {
    border-color: rgba(0, 0, 0, 0.08) transparent transparent transparent;
    border-style: solid;
    border-width: 10px 25px 0 25px;
    bottom: -10px;
    content: "";
    left: 0;
    position: absolute;

    @media ${(props) => props.theme.bp.tabletUp} {
      bottom: -13px;
      border-width: 13px 35px 0 35px;
    }
  }

  &::after {
    color: ${(props) => props.theme.colors.snowdrop};
    content: "${(props) => props.value}";
    font-size: 11px;
    font-weight: bold;
    line-height: 11px;
    left: 50%;
    position: absolute;
    top: 2px;
    transform: translateX(-50%);

    @media ${(props) => props.theme.bp.tabletUp} {
      font-size: 13px;
      line-height: 13px;
      top: 7px;
    }
  }
`;

export const ForestTileStackPost = styled.span<{
  value?: string | number;
  isCentered?: boolean;
  isCallout?: boolean;
}>`
  background-image: url("data:image/svg+xml,%3Csvg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78 35'%3E%3Cellipse cx='39.088' cy='17.248' rx='19.549' ry='2.626' fill='%23222' opacity='.3'/%3E%3C/svg%3E");
  background-position: center 42px;
  background-repeat: no-repeat;
  background-size: 65px;
  bottom: ${(props) => (props.isCentered ? "28px" : "16px")};
  height: 60px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 40px;

  @media ${(props) => props.theme.bp.tabletUp} {
    bottom: ${(props) => (props.isCentered ? "45px" : "20px")};
  }

  &::before {
    background: rgb(159, 109, 61);
    content: "";
    height: 30px;
    left: 50%;
    position: absolute;
    bottom: 4px;
    transform: translateX(-50%);
    width: 4px;

    @media ${(props) => props.theme.bp.tabletUp} {
      height: 37px;
      width: 5px;
    }
  }

  &::after {
    background: ${(props) => props.theme.colors.snowdrop};
    bottom: 14px;
    color: ${(props) => props.theme.colors.night};
    content: "${(props) => props.value}";
    font-size: 11px;
    font-weight: bold;
    left: 50%;
    line-height: 11px;
    padding: 2px 4px 4px;
    position: absolute;
    transform: translateX(-50%);
    min-width: ${(props) => (props.isCallout ? "70px" : "0")};

    @media ${(props) => props.theme.bp.tabletUp} {
      bottom: 17px;
      font-size: 13px;
      line-height: 13px;
    }
  }
`;

export const ForestTilePopover = styled.span<{ message: string }>`
  background-color: ${(props) => props.theme.colors.snowdrop};
  border-radius: 5px;
  display: block;
  height: 32px;
  left: 50%;
  position: absolute;
  top: -45px;
  transform: translateX(-50%);
  width: 120px;
  padding: 6px;
  font-weight: bold;
  text-align: center;

  &::before {
    color: ${(props) => props.theme.colors.night};
    content: "${(props) => props.message}";
  }

  &::after {
    z-index: -1;
    left: 50%;
    bottom: -12px;
    content: "";
    height: 16px;
    width: 12px;
    background-color: ${(props) => props.theme.colors.snowdrop};
    position: absolute;
    transform: translate(-50%, -50%) rotate(45deg);
  }
`;
